import { AuthenticatedUser } from '@generated/authenticate/src';

import isLoggedIn from './isLoggedIn';

const isActiveUser = (user: AuthenticatedUser | undefined): boolean =>
  isLoggedIn(user) &&
  user.roles.filter(role => role.role !== 'Kontoinnehavare').length > 0;

export default isActiveUser;
